import styled from 'styled-components';

import { addMenuHeightMixin } from './styles';

const StyledMain = styled.span`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ${addMenuHeightMixin}
`;

export default StyledMain;
